<div class="atn-assistant-empty-state">
  <div class="atn-assistant-empty-state__header">
    <h3>How can I help?</h3>
    <p class="atn-assistant-empty-state__text">
      Write your question below to start a conversation.
    </p>
  </div>
</div>
